/*
  Custom JavaScript — Global enhancements
*/

(() => {
  // Smooth scroll for anchor links (all pages)
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const href = anchor.getAttribute('href');
        if (!href || href === '#') return;
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  };

  // IntersectionObserver reveal for non-GSAP pages
  const initIOReveal = (root = document) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const revealEls = root.querySelectorAll('[data-reveal]:not(.is-visible)');
    const staggerEls = root.querySelectorAll('[data-reveal-stagger]:not(.is-visible)');
    if (!revealEls.length && !staggerEls.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    revealEls.forEach((el) => io.observe(el));
    staggerEls.forEach((el) => io.observe(el));
  };

  const init = () => {
    initSmoothScroll();
    initIOReveal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    initIOReveal(e.target || document);
  });
})();
